export var BRIDGE_RESPONSE_TYPE;
(function (BRIDGE_RESPONSE_TYPE) {
    BRIDGE_RESPONSE_TYPE["SUCCESS"] = "SUCCESS";
    BRIDGE_RESPONSE_TYPE["API_RESPONSE_ERROR"] = "API_RESPONSE_ERROR";
    BRIDGE_RESPONSE_TYPE["API_UNREGISTER"] = "API_UNREGISTER";
    BRIDGE_RESPONSE_TYPE["BG_WIN_UNRESPONSE"] = "BG_WIN_UNRESPONSE";
    BRIDGE_RESPONSE_TYPE["API_RESPONSE_TIMEOUT"] = "API_RESPONSE_TIMEOUT";
    BRIDGE_RESPONSE_TYPE["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    BRIDGE_RESPONSE_TYPE["INVALD_ACCOUNT_NOACCOUNT"] = "INVALD_ACCOUNT_NOACCOUNT";
    BRIDGE_RESPONSE_TYPE["BG_WIN_NOT_EXIST"] = "BG_WIN_NOT_EXIST";
})(BRIDGE_RESPONSE_TYPE || (BRIDGE_RESPONSE_TYPE = {}));
export const BRIDGE_RESPONSE_CODE = {
    [BRIDGE_RESPONSE_TYPE.SUCCESS]: 0,
    [BRIDGE_RESPONSE_TYPE.API_RESPONSE_ERROR]: -1,
    [BRIDGE_RESPONSE_TYPE.API_UNREGISTER]: -2,
    [BRIDGE_RESPONSE_TYPE.BG_WIN_UNRESPONSE]: -3,
    [BRIDGE_RESPONSE_TYPE.API_RESPONSE_TIMEOUT]: -4,
    [BRIDGE_RESPONSE_TYPE.INVALD_ACCOUNT_NOACCOUNT]: -5,
    [BRIDGE_RESPONSE_TYPE.BG_WIN_NOT_EXIST]: -6,
    [BRIDGE_RESPONSE_TYPE.UNKNOWN_ERROR]: -99,
};
export const sleep = async (t) => new Promise(resolve => {
    setTimeout(resolve, t);
});
export const getname = (str) => {
    const reg = /\b(?<name>[\w\d]+)(\.[\w\d]+)?$/;
    const result = str.match(reg);
    if (!result) {
        return 'unknown';
    }
    return result.groups.name;
};
export const BridgeConnected = 'bridgeConnected';
